import { Component, OnInit, Inject, } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { ConveniosTreeViewService } from '../../services/convenios-tree-view.service';
import { Console, debug } from 'console';
@Component({
    selector: 'app-convenios-add-edit',
    templateUrl: './convenios-add-edit.component.html',
    styleUrls: ['./convenios-add-edit.component.scss'],
    standalone: false
})
export class ConveniosAddEditComponent implements OnInit {
  public addConvenioCriteriosForm: UntypedFormGroup;
  formFiled: boolean;
  formValidity:boolean=false;

  constructor(
    private _dialogRef: MatDialogRef<ConveniosAddEditComponent>,
    private _conveniosTreeViewService: ConveniosTreeViewService,
    private _formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.addConvenioCriteriosForm = new UntypedFormGroup({
      id: new UntypedFormControl(0),
      convenioId: new UntypedFormControl(this.data.convenioId),
      diasDesde: new UntypedFormControl(null,[Validators.min(1), Validators.max(545)]),
      diasHasta: new UntypedFormControl(null,[Validators.min(1), Validators.max(545)]),
      complemento: new UntypedFormControl(null,[Validators.min(0), Validators.max(100)]),
      bajasDesdeDias: new UntypedFormControl(null,[Validators.min(1), Validators.max(545)]),
      bajasHastaDias: new UntypedFormControl(null,[Validators.min(1), Validators.max(545)]),
    });
    this.addConvenioCriteriosForm.valueChanges.subscribe(x => {
      if(this.addConvenioCriteriosForm.valid)
      {
        this.formFiled = false;
      }
  });
  }

  public onClose(): void {
    this._dialogRef.close();
  }
  private checkFormValidity(diasDesde,diasHasta,complemento,bajasDesdeDias,bajasHastaDias)
  {
    
    if(diasDesde || diasHasta || complemento==0  || complemento ||  bajasDesdeDias || bajasHastaDias)
    {
      return true;
    }
    else
    {
      return false;
    }
    
  }
  public onSave(): void {
    this.addConvenioCriteriosForm.markAllAsTouched();
    this.addConvenioCriteriosForm.updateValueAndValidity();
    if(this.addConvenioCriteriosForm.valid)
    {

      this.formValidity=this.checkFormValidity(this.addConvenioCriteriosForm.get('diasDesde').value,this.addConvenioCriteriosForm.get('diasHasta').value, this.addConvenioCriteriosForm.get('complemento').value,this.addConvenioCriteriosForm.get('bajasDesdeDias').value,this.addConvenioCriteriosForm.get('bajasHastaDias').value)
      if(this.formValidity)
      {
          if(this.formValidity && this.addConvenioCriteriosForm.get('complemento').value==null || this.addConvenioCriteriosForm.get('complemento').value<0 || this.addConvenioCriteriosForm.get('complemento').value>100)
          {
            console.log('Fail')
          }
        this._conveniosTreeViewService.addCriterioConvenio(this.addConvenioCriteriosForm.value).subscribe(res => {
        if (res) {
          this.onClose();
        }
        });
      }
      else
      {
        this.formFiled = true;
      }
     
    }
    
  }
  

}
